import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadLegalDocuments } from '@app/core/store/legal-documents/actions';
import { SettingsService } from '@app/core/settings/settings.service';
import { Observable } from 'rxjs';
import {
  selectAllLegalDocuments,
  selectCookiePolicy,
  selectPrivacyPolicy,
  selectTerms,
} from '../store/legal-documents/selectors';
import { ApiLegalDocument, ApiLegalDocuments } from '@app/core/legal-documents/api-legal-documents';


@Injectable({
  providedIn: 'root',
})
export class LegalDocumentsFacade {
  constructor(protected store: Store,
              protected settingsService: SettingsService) { }

  public loadData(): void {
    this.settingsService.getSettingsOnce()
      .subscribe(() =>
        this.store.dispatch(loadLegalDocuments()),
      );
  }

  public getAllDocuments(): Observable<ApiLegalDocuments> {
    return this.store.select(selectAllLegalDocuments);
  }

  public getTerms(): Observable<ApiLegalDocument | null> {
    return this.store.select(selectTerms);
  }

  public getPrivacyPolicy(): Observable<ApiLegalDocument | null> {
    return this.store.select(selectPrivacyPolicy);
  }

  public getCookiePolicy(): Observable<ApiLegalDocument | null> {
    return this.store.select(selectCookiePolicy);
  }
}
